import React from 'react';
import { Text, SubText } from '../Text/Text';
import { cn } from '../../utils/cn';
export const DefaultSection = {
    id: 'default',
    name: 'Uncategorized',
    color: '#E8E9F1',
};
export function Section({ section, sub = false, className, ...rest }) {
    const _section = (section !== null && section !== void 0 ? section : DefaultSection); // handle null case from db
    const TextComponent = sub ? SubText : Text;
    return (React.createElement("div", Object.assign({ className: cn(className, 'flex flex-row items-center') }, rest),
        React.createElement("div", { className: cn('h-2 w-2 bg-smudge rounded-full', sub ? 'mr-1' : 'mr-2'), style: { backgroundColor: _section.color } }),
        React.createElement(TextComponent, null, _section.name)));
}
